/**
* This component allows you to expand or contract long text when needed base on data attributes
* data-show-more for the see more button and data-long-text for the text and data-read-more-dots for the dots
*/
define(
  'longTextHandler',[
    'builderShowcaseObserver',
    'i18n!nls/res',
    'event',
  ],
  (
    builderShowcaseObserver,
    res
  ) => {
    'use strict';

    /**
    * @constructor
    * This component handles the long text see more see less text toggles between the short and long version.
    *
    */
    function longTextHandler() {
    }

    /**
    * @private
    * SetListenersLongText: set listeners for long text.
    *
    */
    function SetListenersLongText() {
      const showMoreLinks = document.querySelectorAll('[data-show-more]');

      if (!showMoreLinks || !showMoreLinks.length) {
        return;
      }

      const linkClickHandler = function () {
        const isShowMore = this.getAttribute('data-show-more') === '0';
        const readMoreDots = this.parentElement.querySelector('[data-read-more-dots]');
        const longText = this.parentElement.querySelector('[data-long-text]');
        if (isShowMore) {
          this.setAttribute('data-show-more', 1);
          this.style.display = 'block';
          this.innerHTML = res.showLess;

          readMoreDots.style.display = 'none';
          longText.style.display = 'inline';
        } else {
          this.setAttribute('data-show-more', 0);
          this.style.display = 'inline';
          this.innerHTML = res.more;

          readMoreDots.style.display = 'inline';
          longText.style.display = 'none';
        }
      };

      for (let i = 0; i < showMoreLinks.length; i += 1) {
        showMoreLinks[i].addEventListener('click', linkClickHandler);
      }
    }

    /**
    * @public
    * update: function for receiving notifications about state changes
    *
    */
    longTextHandler.update = function SetListeners() {
      SetListenersLongText();
    };

    SetListenersLongText();
    builderShowcaseObserver.subscribe('onReviewsSectionLoaded', longTextHandler);
  }

);

